import request from "../utils/request";

export async function filterBranchCodeList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Branch/CodeList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterBranchCodeListForDealer() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Branch/CodeListForDealer").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterStockOrderList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("StockOrder/GetForFilter", {params: {branchId: branchId}}).then(res => {
        let resData = res.data;
        resolve(resData);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterBillNoList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("Bill/GetBillNos", {params: {branchId: branchId}}).then(res => {
        let resData = res.data;
        resolve(resData);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterRawMaterialDescriptionList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("RawMaterial/GetDescriptions").then(res => {
        let resData = res.data;
        resolve(resData);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterVariantList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("RawMaterial/GetVariants").then(res => {
        let resData = res.data;
        resolve(resData);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterKdvList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("RawMaterial/GetKdvs").then(res => {
        let resData = res.data;
        resolve(resData);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterBranchNameList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("User/BranchNameList").then(res => {
        let resData = res.data;
        resolve(resData);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterProductNameList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Product/ProductNameList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterOrderList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("Cart/OrderIdList", {params: {branchId: branchId}}).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterRecipeList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Recipe/GetRecipeNames").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterHalfMadeList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("HalfMadeProduct/GetNames").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterExtraNameList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("ProductExtra/NameList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterRoleList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("User/GetRoles").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterUserEmailList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("User/GetEmails", {params: {branchId: branchId}}).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterUserPhoneNumbersList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("User/GetPhoneNumbers", {params: {branchId: branchId}}).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterExtraOriginList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("ProductExtra/GetOrigins").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterUserNameList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("User/GetUserNames", {params: {branchId: branchId}}).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterUserTcNumbersList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("User/GetTcNumbers", {params: {branchId: branchId}}).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterPersonalNameList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("User/PersonalNameList", {params: {branchId: branchId}}).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterPaymentMethodNameList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("PaymentMethod/NameList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterBranchPhoneNumberList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Branch/PhoneNumberList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterBranchEmailList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Branch/EmailList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterBranchAddressList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Branch/AddressList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterUnitList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Unit/GetNames").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterUnitOriginList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Unit/GetOrigins").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterUnitOriginQuantityList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Unit/GetOriginQuantities").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterUnitShortNameList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Unit/GetShortNames").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterStateList(cityId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("Branch/StateList?cityId=" + cityId).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterCityList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Branch/CityList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterExpenseDefinitionList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("ExpenseDefinition/NameList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterExpenseDescriptionList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Expense/DescriptionList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterRawMaterialList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("RawMaterial/NameListForFilter").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterLossDescriptionList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Loss/DescriptionList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterLossReasonList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("LossReason/NameList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterDistributorList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/DistributorListForFilter").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterSupplierList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/SupplierListForFilter").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterStockList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("Stock/StockListForFilter", {params: {branchId: branchId}}).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterStockCodeList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("Stock/StockCodeListForFilter", {params: {branchId: branchId}}).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterCategoryList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("ProductCategory/NameList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterSupplierEmailList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetEmails").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterSupplierPhoneNumberList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetPhoneNumbers").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterSupplierOwnerList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetOwners").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterCustomerEmailList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Report/FilterCustomerEmail").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterCustomerPhoneNumberList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Report/FilterCustomerPhoneNumber").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterSupplierBankList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetBanks").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterSupplierBankAccountList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetBankAccounts").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterSupplierAddressList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetAddresses").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterDistributorEmailList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetDistEmails").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterDistributorPhoneNumberList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetDistPhoneNumbers").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterDistributorOwnerList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetDistOwners").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterDistributorBankList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetDistBanks").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterDistributorBankAccountList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetDistBankAccounts").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterDistributorAddressList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Supplier/GetDistAddresses").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}

export async function filterDiscountDescriptionList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Discount/GetDiscountDescriptions").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error);
    }
  })
}

export async function filterRawMaterialCategoryList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("RawMaterialCategory/NameList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error);
    }
  })
}

export async function filterDrawList() {
  return new Promise((resolve, reject) => {
    try {
      request.get("Draw/DrawNameList").then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}
export async function filterTableList(branchId) {
  return new Promise((resolve, reject) => {
    try {
      request.get("BranchTables/GetTablesForFilter", { params: { branchId: branchId } }).then(res => {
        resolve(res.data);
      });
    } catch (error) {
      reject(error)
    }
  });
}
